import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { TogglitScreenAuthorization } from './togglit-screen-auth';

// Prevents navigation away from the application create form if the user has unsaved changes
@Injectable()
export class TogglitScreenAuthGuard implements CanDeactivate<TogglitScreenAuthorization> {
  canDeactivate(component: TogglitScreenAuthorization) {
    let allowed = component.canDeactivate();
    return allowed;
  }
}



// WEBPACK FOOTER //
// /app/src/app/screens/togglit-screen-auth-guard.ts